module.exports = __webpack_public_path__ + "static/media/mem9.c37b5b7e.jpg";